module.exports = __webpack_public_path__ + "static/media/logout.1852cf02.png";